export default "__VITE_ASSET__CWnrzdNN__"